const numberFormat = new Intl.NumberFormat('ja-JP');
const byteFormat = new Intl.NumberFormat('ja-JP', {
  maximumFractionDigits: 1,
});

export function formatNumber(value) {
  const number = Number(value || 0);
  return numberFormat.format(Number.isFinite(number) ? number : 0);
}

export function formatBytes(value) {
  const bytes = Number(value || 0);
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  return `${byteFormat.format(bytes / (1024 ** index))} ${units[index]}`;
}

export function formatDateKey(value) {
  const text = String(value || '');
  if (!/^\d{8}$/.test(text)) return text || '-';
  return `${text.slice(0, 4)}-${text.slice(4, 6)}-${text.slice(6, 8)}`;
}

export function dateKeyFromInput(value) {
  const text = String(value || '').trim();
  if (!text) return '';
  return text.replace(/-/g, '');
}

export function statisticsStatusLabel(status) {
  if (status === 'success') return '成功';
  if (status === 'partial') return '一部取得失敗';
  if (status === 'failed') return '失敗';
  return status || '未実行';
}

export function statisticsStatusClass(status) {
  if (status === 'success') return 'success';
  if (status === 'partial') return 'warning';
  if (status === 'failed') return 'danger';
  return 'neutral';
}

function normalizeStorageEntry(value, metrics) {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    const files = Number(value.files || 0);
    const bytes = Number(value.bytes || 0);
    return {
      files,
      bytes,
      avgBytes: files > 0 ? bytes / files : 0,
      mode: 'full',
    };
  }

  const numeric = Number(value || 0);
  if (isLegacyStorageByContentType(metrics)) {
    return {
      files: numeric,
      bytes: 0,
      avgBytes: 0,
      mode: 'legacyCount',
    };
  }

  return {
    files: 0,
    bytes: numeric,
    avgBytes: 0,
    mode: 'legacyBytes',
  };
}

/**
 * Storage種別テーブル用の行データ
 */
export function buildStorageTypeRows(metrics) {
  const map = metrics?.media?.storageByContentType || {};
  return Object.entries(map)
    .map(([contentType, value]) => ({
      contentType,
      ...normalizeStorageEntry(value, metrics),
    }))
    .sort((a, b) => b.bytes - a.bytes || b.files - a.files || a.contentType.localeCompare(b.contentType, 'ja'));
}

export function isLegacyStorageByContentType(metrics) {
  const entries = Object.values(metrics?.media?.storageByContentType || {});
  if (entries.length === 0) return false;

  const totalBytes = Number(metrics?.media?.storageBytes || 0);
  const totalFiles = Number(metrics?.media?.storageFiles || 0);
  const sumValues = entries.reduce((sum, value) => sum + Number(value || 0), 0);
  if (totalBytes <= 0 || sumValues <= 0) return false;

  if (totalFiles > 0 && sumValues <= totalFiles && sumValues < totalBytes / 512) {
    return true;
  }

  return sumValues < totalBytes / 512;
}

export function formatStorageByContentTypeValue(value, metrics) {
  if (isLegacyStorageByContentType(metrics)) {
    return `${formatNumber(value)} ファイル`;
  }
  return formatBytes(value);
}
